import React, { useState, useEffect, useRef } from 'react';
import classes from './CustomDropdown.module.scss';

const CustomDropdown = ({ options, selectedValue, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSelect = (value) => {
    onSelect(value);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className={classes.customDropdown} ref={dropdownRef}>
      <button
        type="button"
        className={classes.dropdownButton}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedValue}
        <span className={classes.arrow}>&#9662;</span>
      </button>
      {isOpen && (
        <ul className={classes.dropdownMenu}>
          {options.map((option) => (
            <li
              key={option.value}
              className={`${classes.dropdownItem} ${
                option.label === selectedValue ? classes.selected : ''
              }`}
              onClick={() => handleSelect(option.value)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;
